<div class="card-white">
  <ng-container *ngIf="formPrincipal">
    <div class="title-section">
      <h1 class="header-title">
        {{ modelRecived ? 'Editar Definición General' : 'Agregar Definición General' }}
      </h1>
    </div>

    <form [formGroup]="form" (submit)="modelRecived ? update() : create()" appPermissionControl="P139F0001">
      <div mat-dialog-content>
        <!-- Capital -->
        <div class="titleFm" style="width: 200px">CAPITAL</div>
        <div class="content-section">
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Pagos de capital sin intereses</mat-label>
              <input min="0" matInput placeholder="123" formControlName="periodoCapitalSinIntereses" type="number" appPermissionControl="P139K0001" />
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-select formControlName="periodoCapitalSinInteresesList" appPermissionControl="P139K0002">
                <mat-option [value]="1"> Fijo </mat-option>
                <mat-option [value]="2"> Opcional </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="line-break"></div>
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Periodos sin Capital e Intereses</mat-label>
              <input min="0" matInput placeholder="123" formControlName="periodoSinCapital" type="number" appPermissionControl="P139K0003" />
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-select formControlName="periodoSinCapitalList" appPermissionControl="P139K0004">
                <mat-option [value]="1"> Fijo </mat-option>
                <mat-option [value]="2"> Opcional </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Interes -->
        <div class="titleFm" style="width: 200px">INTERÉS</div>
        <div class="content-section">
          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Tasa mínima</mat-label>
              <mat-select formControlName="claveTasa" appPermissionControl="P139K0005">
                <mat-option> -- Selecciona -- </mat-option>
                <mat-option *ngFor="let tasa of tasas" [value]="tasa.clave"> {{ tasa.clave }} | {{ tasa.descripcion }} </mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="formValue('claveTasa')?.errors?.required"
                >Requerido</mat-error
                > -->
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Cálculo</mat-label>
              <mat-select formControlName="calculate" appPermissionControl="P139K0006">
                <mat-option [value]="0"> -- Seleccionar -- </mat-option>
                <mat-option [value]="1"> Al Pago </mat-option>
                <mat-option [value]="2"> Al Corte </mat-option>
                <mat-option [value]="2"> Al Crear </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="line-break"></div>

          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Tasa máxima</mat-label>
              <mat-select formControlName="claveTasa2" appPermissionControl="P139K0007">
                <mat-option> -- Selecciona -- </mat-option>
                <mat-option *ngFor="let tasa of tasas" [value]="tasa.clave"> {{ tasa.clave }} | {{ tasa.descripcion }} </mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="formValue('claveTasa')?.errors?.required"
                                >Requerido</mat-error
                                > -->
            </mat-form-field>
          </div>

          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Pagos de capital sin intereses</mat-label>
              <input matInput placeholder="123" formControlName="pagoCapitalSinInteresTasa" type="number" appPermissionControl="P139K0008" />
            </mat-form-field>
          </div>

          <div class="col-2">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-select formControlName="pagoCapitalSinInteresTasaList" appPermissionControl="P139K0009">
                <mat-option [value]="1"> Fijo </mat-option>
                <mat-option [value]="2"> Opcional </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Aplicación</mat-label>
              <mat-select formControlName="aplicacionTasa" appPermissionControl="P139K0010">
                <mat-option [value]="1"> Tasa Fija </mat-option>
                <mat-option [value]="2"> Tasa Variable </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-4">
            <mat-checkbox formControlName="interesesSaldos" appPermissionControl="P139K0011">Intereses sobre Saldos</mat-checkbox>
          </div>
        </div>

        <div class="content-section-invisible" style="margin-top: 20px">
          <div class="col-4">
            <div class="subcontent-section col-12">
              <mat-form-field class="largoFm" color="accent" appearance="outline">
                <mat-label>Ventas Abono</mat-label>
                <mat-select formControlName="ventasAbono" appPermissionControl="P139K0012">
                  <mat-option [value]="0"> No </mat-option>
                  <mat-option [value]="1"> Si </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="subcontent-section col-12" style="margin-top: 20px">
              <mat-form-field class="largoFm" color="accent" appearance="outline">
                <mat-label>Aplicación Pagos</mat-label>
                <mat-select formControlName="aplicacionPagos" appPermissionControl="P139K0013">
                  <mat-option [value]="1"> Vertical </mat-option>
                  <mat-option [value]="2"> Horizontal </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="col-7">
            <div class="subcontent-section col-12">
              <mat-form-field class="largoFm" color="accent" appearance="outline">
                <mat-label>Tipo Armonización</mat-label>
                <mat-select formControlName="tipoArmonizacion" appPermissionControl="P139K0014">
                  <mat-option [value]="1"> Saldos Insolutos </mat-option>
                  <mat-option [value]="2"> Global </mat-option>
                  <mat-option [value]="4"> Decreciente </mat-option>
                  <mat-option [value]="5"> Gradiante Mes-Mes </mat-option>
                  <mat-option [value]="6"> Gradiante Año-Año </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- Desplegable Gradiente - Solo visible cuando tipoArmonizacion es 5 o 6 -->
              <mat-form-field class="largoFm" color="accent" appearance="outline" *ngIf="form.get('tipoArmonizacion')?.value === 5 || form.get('tipoArmonizacion')?.value === 6">
                <mat-label>Gradiente</mat-label>
                <mat-select formControlName="gradiente" appPermissionControl="P139K0016">
                  <mat-option> -- Selecciona -- </mat-option>
                  <mat-option *ngFor="let tasa of tasas" [value]="tasa.clave"> {{ tasa.clave }} | {{ tasa.descripcion }} </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-checkbox formControlName="pagosPredefinidos" appPermissionControl="P139K0015">Pagos Predefinidos</mat-checkbox>
            </div>
          </div>
        </div>

        <div class="content-section-invisible" style="margin-top: 20px">
          <div class="subcontent-section col-4">
            <div class="content-section-invisible">
              <div class="col-6">
                <mat-form-field class="largoFm" color="accent" appearance="outline">
                  <mat-label>Cuota inicial (%)</mat-label>
                  <input matInput placeholder="123" formControlName="enganche" type="number" step="0.01" min="0" appPermissionControl="P139K0016" />
                </mat-form-field>
              </div>

              <div class="col-5">
                <mat-form-field class="largoFm" color="accent" appearance="outline">
                  <input matInput placeholder="123" formControlName="engancheVal" type="number" step="0.01" min="0" appPermissionControl="P139K0017" />
                </mat-form-field>
              </div>
            </div>

            <mat-checkbox formControlName="restarEnganche" appPermissionControl="P139K0018">Restar Cuota Inicial</mat-checkbox>
          </div>
          <div class="subcontent-section col-3" style="padding-bottom: 20px">
            <mat-checkbox formControlName="modificarCuotas" appPermissionControl="P139K0019">Modificar Cuotas</mat-checkbox>
          </div>
          <div class="subcontent-section col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Pagos Anticipados</mat-label>
              <mat-select formControlName="pagosAnticipados" appPermissionControl="P139K0020">
                <mat-option [value]="0"> Próximas Cuotas</mat-option>
                <mat-option [value]="1"> Reduce Cuota </mat-option>
                <mat-option [value]="2"> Reduce Plazo </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="content-section-invisible" style="margin-top: 20px">
          <div class="subcontent-section col-4">
            <div class="content-section-invisible">
              <div class="col-6">
                <mat-form-field class="largoFm" color="accent" appearance="outline">
                  <mat-label>Valor Residual (%)</mat-label>
                  <input matInput placeholder="123" formControlName="valorResidual" type="number" step="0.01" min="0" appPermissionControl="P139K0021" />
                </mat-form-field>
              </div>
              <div class="col-5">
                <mat-form-field class="largoFm" color="accent" appearance="outline">
                  <input matInput placeholder="123" formControlName="valorResidualVal" type="number" step="0.01" min="0" appPermissionControl="P139K0022" />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="subcontent-section col-3">
            <mat-checkbox formControlName="modificarPrecio" style="padding-bottom: 20px" appPermissionControl="P139K0023">Modificar Precio</mat-checkbox>
          </div>
          <div class="col-4">
            <div class="content-section-invisible">
              <div class="subcontent-section col-12">
                <mat-checkbox formControlName="cobrarDiasExtras" style="padding-bottom: 20px" appPermissionControl="P139K0024">Cobras Días Extras</mat-checkbox>
              </div>
              <div class="subcontent-section col-12" style="margin-top: 20px">
                <mat-checkbox formControlName="firstPayment" style="padding-bottom: 15px" appPermissionControl="P139K0025">First Payment</mat-checkbox>
              </div>
            </div>
          </div>
        </div>

        <!-- IVAS -->
        <div class="titleFm" style="width: 200px">IVAS</div>
        <div class="content-section">
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>IVA Interés</mat-label>
              <input matInput placeholder="123" formControlName="ivaIntereses" type="number" step="0.01" min="0" appPermissionControl="P139K0026" />
            </mat-form-field>
          </div>

          <div class="col-2">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-select formControlName="ivaInteresesList" appPermissionControl="P139K0027">
                <mat-option [value]="1"> Al Pago </mat-option>
                <mat-option [value]="2"> Al Crear </mat-option>
                <mat-option [value]="3"> No Calcular </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="line-break"></div>

          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>IVA Capital</mat-label>
              <input matInput placeholder="123" formControlName="ivaCapital" type="number" step="0.01" min="0" appPermissionControl="P139K0028" />
            </mat-form-field>
          </div>

          <div class="col-2">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-select formControlName="ivaCapitalList" appPermissionControl="P139K0029">
                <mat-option [value]="1"> Al Pago </mat-option>
                <mat-option [value]="2"> Al Crear </mat-option>
                <mat-option [value]="3"> No Calcular </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- FRECUENCIA DE PAGOS -->
        <div class="titleFm" style="width: 200px">FRECUENCIA DE PAGOS</div>
        <div class="content-section">
          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Frecuencia de Pagos</mat-label>
              <mat-select formControlName="frecuenciaPagos" appPermissionControl="P139K0030">
                <mat-option [value]="1"> Semanal</mat-option>
                <mat-option [value]="2"> Quincenal </mat-option>
                <mat-option [value]="3"> Mensual </mat-option>
                <mat-option [value]="4"> Bimestral </mat-option>
                <mat-option [value]="5"> Trimestrar </mat-option>
                <mat-option [value]="6"> Semestral </mat-option>
                <mat-option [value]="7"> Anual </mat-option>
                <mat-option [value]="8"> Diario </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          
          <!-- Checkbox Pago de intereses mensual - Solo visible para bimestral, trimestral, semestral, anual y diario -->
          <div class="col-4" *ngIf="form.get('frecuenciaPagos')?.value === 4 || form.get('frecuenciaPagos')?.value === 5 || form.get('frecuenciaPagos')?.value === 6 || form.get('frecuenciaPagos')?.value === 7 || form.get('frecuenciaPagos')?.value === 8">
            <mat-checkbox formControlName="pagoInteresesMensual">Pago de intereses mensual</mat-checkbox>
          </div>
          
          <div class="line-break"></div>
          <div class="col-4">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Periodo Mensual</mat-label>
              <mat-select formControlName="perdiodoMensual" appPermissionControl="P139K0031">
                <mat-option *ngFor="let periodo of mensualPer" [value]="periodo.iValor">
                  {{ periodo.sEtiqueta }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <mat-checkbox formControlName="ajustarDiaHabil" appPermissionControl="P139K0032">Ajustar a Día Hábil</mat-checkbox>
        </div>

        <!-- PRIMERA MENSUALIDAD -->
        <div class="titleFm" style="width: 250px">PRIMERA MENSUALIDAD</div>
        <div class="content-section">
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Días</mat-label>
              <input min="0" matInput placeholder="123" formControlName="dias" type="number" appPermissionControl="P139K0033" />
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Fecha</mat-label>
              <input min="0" matInput placeholder="123" formControlName="fecha" type="number" appPermissionControl="P139K0034" />
            </mat-form-field>
          </div>
          <div class="line-break"></div>
          <div class="col-3">
            <mat-form-field class="largoFm" color="accent" appearance="outline">
              <mat-label>Meses</mat-label>
              <input min="0" matInput placeholder="123" formControlName="meses" type="number" appPermissionControl="P139K0035" />
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="col-6" style="margin-top: 35px">
        <div mat-dialog-actions>
          <ng-container *ngIf="!loading"
            ><button class="btn-cancel" type="button" mat-raised-button (click)="close()" style="margin-right: 10px" appPermissionControl="P139B0001">
              <mat-icon>arrow_back</mat-icon>
              Atrás
            </button>
            <button class="btn-success" mat-raised-button appPermissionControl="P139B0002">
              <mat-icon>save</mat-icon>
              {{ modelRecived ? 'Actualizar' : 'Guardar' }}
            </button>
          </ng-container>
          <button *ngIf="loading" class="botonGrandeFm" mat-raised-button color="accent" type="button" appPermissionControl="P139B0003">
            Cargando
            <mat-progress-bar mode="buffer"></mat-progress-bar>
          </button>
        </div>
      </div>
    </form>
  </ng-container>

  <ng-container *ngIf="selectCocepto">
    <button mat-button color="accent" type="button" (click)="changeBoolean('form')" appPermissionControl="P139B0004"><mat-icon>west</mat-icon> Regresar</button>
    <app-select-concepto></app-select-concepto>
  </ng-container>

  <ng-container *ngIf="selectTasa">
    <button mat-button color="accent" type="button" (click)="changeBoolean('form')" appPermissionControl="P139B0005"><mat-icon>west</mat-icon> Regresar</button>
    <app-select-tasa></app-select-tasa>
  </ng-container>
</div>
